import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")!

  return (_openBlock(), _createBlock(_component_message_wrap, {
    isShowMessageTail: _ctx.isShowMessageTail,
    message: _ctx.message,
    avatar: _ctx.avatar,
    onInit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('init')))
  }, null, 8, ["isShowMessageTail", "message", "avatar"]))
}